export default __webpack_public_path__ + "static/media/room-1.ce10ecae.jpeg";